export default "__VITE_ASSET__CvxyObHZ__"